import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';
import MainWheel from '@/modules/wheel/views/main-view';
import MainWheelWDrag from '@/modules/wheel/views/main-view-w-drag';

//import './index.scss';

type TemplateProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const Template = (componentProps: TemplateProps) => {
  let props = componentProps;

  const dataElementContext = React.useContext(DataElementContext);
  [props] = processComponentProps(props, dataElementContext);

  if (props.properties?.enableDrag) {
    const url = new URL(window.location.href);
    let id = '';
    if (url.searchParams.has('id')) {
      id = url.searchParams.get('id') || '';
    }

    return <MainWheelWDrag wheelSetupId={id} />;
  }

  return <MainWheel />;
};

export default Template;
